import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, take } from 'rxjs/operators';
import { AccessControlService } from '../service/helpers/acces-control.service';
import { LoaderService } from 'src/app/shared/service/utils/loader.service';

@Injectable({ providedIn: 'root' })
export class GlobalGuard implements CanActivate {

  constructor(
    private readonly accessControl: AccessControlService,
    private readonly authService: MsalService,
    private readonly loaderService: LoaderService,
    private readonly msalService: MsalService,
    private readonly msalBroadcast: MsalBroadcastService
  ) {}

  canActivate(): boolean {
    const instance = this.msalService.instance;

    if (!instance?.getAllAccounts().length) return true;

    const encryptedClaims = localStorage.getItem('userClaims');

    if (!encryptedClaims) {
      console.warn('❌ userClaims no existe — sesión inválida');
      this.handleLogoutSafely();
      return false;
    }

    const allowed = this.accessControl.canAccessSystem();

    if (!allowed) {
      console.warn('Acceso denegado — usuario sin permisos');
      this.handleLogoutSafely();
      return false;
    }

    return true;
  }

  private handleLogoutSafely(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.loaderService.show('Cerrando sesión');

    this.msalBroadcast.inProgress$
      .pipe(
        filter(status => status === InteractionStatus.None),
        take(1)
      )
      .subscribe({
        next: () => {
          this.authService.logoutRedirect().subscribe({
            error: (error: unknown) => console.error('Error al intentar cerrar sesión:', error)
          });
        },
        error: (err) => console.error('Error esperando MSAL libre:', err)
      });
  }
}
